import { useIntervalValue } from '@/utils'
import { useTranslate } from '@ur-solutions/react-hooks'
import { type HTMLAttributes } from 'react'

interface Props extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  children?: string
  finished?: boolean
}

export function TextEllipsisLoader({
  children,
  className,
  finished = false,
}: Props) {
  const translations = useTranslate({
    loading: 'components.text-ellipsis-loader.loading',
  })

  const ellipsis = useIntervalValue<string>(
    prev => {
      if (!prev) return '.'
      if (prev.length >= 3) return '.'
      return prev + '.'
    },
    500,
    finished
  )

  return (
    <span className={className}>
      {children ?? translations.loading}
      {ellipsis}
    </span>
  )
}
